/** Bìa tờ lịch không có bộ chọn (đầu khối "hôm nay"). */
export default function LeafBand({ left, right }: { left: string; right: string }) {
  return (
    <div className="relative flex items-center justify-between rounded-t-lg bg-leaf px-4 py-3 text-white sm:px-6">
      <h2 className="font-slab text-xl font-bold sm:text-2xl">{left}</h2>
      <span className="font-slab num text-xl font-bold sm:text-2xl">{right}</span>
      <span aria-hidden className="absolute left-1/2 top-2 hidden h-3 w-3 -translate-x-1/2 rounded-full bg-background/90 ring-2 ring-black/10 sm:block" />
    </div>
  );
}
